import { Link } from 'react-router-dom';

export default function HeroSection() {
  return (
    <section className="relative min-h-screen bg-zinc-950 overflow-hidden flex flex-col">
      <div className="absolute inset-0">
        <img
          src="https://public.readdy.ai/ai/img_res/e65788e9953234a8fab1ea52e00babac.jpg"
          alt="AxisPoint Medical"
          className="w-full h-full object-cover object-top opacity-30"
        />
        <div className="absolute inset-0 bg-gradient-to-r from-zinc-950 via-zinc-950/85 to-zinc-950/40"></div>
      </div>

      {/* Coral accent line */}
      <div className="absolute left-0 top-0 h-full w-1 bg-gradient-to-b from-rose-500 via-rose-400 to-transparent"></div>

      <div className="relative z-10 flex-1 flex flex-col justify-center px-8 md:px-16 lg:px-24 pt-28 pb-16">
        <div className="max-w-3xl">
          <div className="flex items-center gap-3 mb-10">
            <div className="w-8 h-px bg-rose-500"></div>
            <span className="text-rose-400 text-xs font-semibold uppercase tracking-[0.25em]">
              Now Accepting New Patients
            </span>
          </div>

          <h1
            className="text-5xl md:text-7xl lg:text-8xl font-black text-white leading-[0.9] mb-8 tracking-tight"
            style={{ fontFamily: "'Syne', sans-serif" }}
          >
            Primary<br />
            <span className="text-rose-500">Care</span><br />
            Reimagined.
          </h1>

          <p className="text-zinc-400 text-base md:text-lg leading-relaxed mb-12 max-w-lg">
            AxisPoint Medical delivers compassionate, comprehensive primary care for every stage of life — from preventive wellness to complex chronic disease management.
          </p>

          <div className="flex flex-col sm:flex-row gap-4 mb-16">
            <Link
              to="/book-appointment"
              className="group inline-flex items-center gap-3 px-8 py-4 bg-rose-500 text-white font-bold rounded-full hover:bg-rose-400 transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              Book an Appointment
              <span className="w-6 h-6 flex items-center justify-center bg-white/20 rounded-full group-hover:translate-x-1 transition-transform">
                <i className="ri-arrow-right-line text-sm"></i>
              </span>
            </Link>
            <Link
              to="/services"
              className="inline-flex items-center gap-2 px-8 py-4 border border-zinc-700 text-zinc-300 hover:border-zinc-500 hover:text-white font-medium rounded-full transition-all duration-200 whitespace-nowrap cursor-pointer text-sm"
            >
              Explore Services
            </Link>
          </div>

          <div className="flex flex-wrap gap-10 pt-8 border-t border-zinc-800">
            {[
              { value: '15+', label: 'Years of Care' },
              { value: '8,500+', label: 'Patients Served' },
              { value: '4.9', label: 'Star Rating' },
              { value: 'Same-Day', label: 'Urgent Visits' },
            ].map((stat) => (
              <div key={stat.label}>
                <div
                  className="text-2xl md:text-3xl font-black text-white"
                  style={{ fontFamily: "'Syne', sans-serif" }}
                >
                  {stat.value}
                </div>
                <div className="text-zinc-500 text-xs mt-1 uppercase tracking-wider">{stat.label}</div>
              </div>
            ))}
          </div>
        </div>
      </div>

      <div className="relative z-10 px-8 md:px-16 lg:px-24 pb-8 flex items-center gap-3">
        <div className="w-6 h-6 flex items-center justify-center border border-zinc-700 rounded-full animate-bounce">
          <i className="ri-arrow-down-line text-zinc-500 text-xs"></i>
        </div>
        <span className="text-zinc-600 text-xs uppercase tracking-widest">Scroll to explore</span>
      </div>
    </section>
  );
}
